export const BUTTONS = "BUTTONS";
export const CATALOGUE = "CATALOG";
export const LIMITED_TIME_OFFER = "LIMITED_TIME_OFFER";
